var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        _setup.FormSidebarBtn,
        {
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _setup.onClick.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "me-2 bi-archive" }),
          _vm._v("\n    " + _vm._s(_setup.buttonText) + "\n"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }